import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { trackViewContent } from '../hooks/useMetaPixel';
export function HeroSection() {
  useEffect(() => {
    trackViewContent();
  }, []);
  const scrollToOffer = () => {
    const element = document.getElementById('offer-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      window.open('https://cocinaproductiva.com/cart/46911022334105:1', '_blank');
    }
  };
  return <section className="relative bg-cream-ivory overflow-hidden pb-12 md:pb-20" data-id="element-147">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-gold-matte opacity-10 blur-3xl pointer-events-none" data-id="element-148"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-96 h-96 rounded-full bg-taupe opacity-10 blur-3xl pointer-events-none" data-id="element-149"></div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-150">
        {/* Product Image FIRST */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-8 flex justify-center cursor-pointer" onClick={scrollToOffer} data-id="element-151">
          <div className="relative w-full max-w-md" data-id="element-152">
            <div className="absolute inset-0 bg-gold-matte rounded-full blur-3xl transform scale-75 opacity-20 animate-pulse" data-id="element-153"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9XXCpYSRMTjmnLuTvPyend/mockup_ebook_principal.jpg" alt="Ebook Desayunos Sorpresa Rentables" className="relative z-10 w-full h-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-154" />
          </div>
        </motion.div>

        {/* Headlines */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-155">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 text-coffee-dark font-heading" data-id="element-156">
            Desayunos sorpresa rentables:{' '}
            <span className="text-gold-matte" data-id="element-157">la guía paso a paso</span> para
            empezar desde cero y generar tus primeros 300 USD en 30 días
          </h1>
          <p className="text-lg md:text-xl text-taupe font-bold mb-4 italic" data-id="element-158">
            (sin recetas mágicas: con método, números claros y ventas reales).
          </p>

          <div className="w-24 h-1 bg-gold-matte mx-auto mb-8 rounded-full" data-id="element-159"></div>

          <p className="text-lg md:text-xl text-text-body mb-10 leading-relaxed max-w-3xl mx-auto font-medium" data-id="element-160">
            Para mujeres en Latinoamérica que quieren emprender desde casa, con
            baja inversión, armar pedidos que se venden solos y dejar de
            improvisar en Instagram, Facebook y WhatsApp.
          </p>
        </motion.div>

        {/* Bullets */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-white p-6 md:p-8 rounded-2xl shadow-xl border border-beige-sand mb-10 max-w-2xl mx-auto text-left" data-id="element-161">
          <ul className="space-y-4" data-id="element-162">
            {['Cómo ordenar tu negocio desde el día 1 (sin caos ni "hacer de todo").', 'Cómo calcular costos y precios para que sí te quede margen.', 'Cómo vender con mensajes simples (sin sonar agresiva ni "vendedora rara").'].map((item, index) => <li key={index} className="flex items-start" data-id="element-163">
                <CheckCircle2Icon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-164" />
                <span className="text-coffee-dark font-semibold text-lg" data-id="element-165">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        {/* CTA Area */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col items-center" data-id="element-166">
          <div className="mb-3 text-center" data-id="element-167">
            <span className="inline-block bg-red-100 text-red-600 font-bold px-4 py-1 rounded-full text-sm mb-2 animate-pulse" data-id="element-168">
              OFERTA LIMITADA
            </span>
            <p className="text-xl font-bold text-coffee-dark" data-id="element-169">
              <span className="line-through text-taupe-light mr-2" data-id="element-170">
                $60.999
              </span>
              <span className="text-3xl text-green-600" data-id="element-171">$14.999</span>
              <span className="text-sm ml-2 bg-green-100 text-green-800 px-2 py-1 rounded" data-id="element-172">
                75% de descuento
              </span>
            </p>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 text-sm text-taupe font-medium mt-2" data-id="element-173">
            <div className="flex items-center" data-id="element-174">
              <ShieldCheckIcon className="w-4 h-4 mr-1 text-green-500" data-id="element-175" />
              Pago seguro con Mercado Pago
            </div>
            <div className="hidden md:block text-taupe-light" data-id="element-176">•</div>
            <div className="flex items-center" data-id="element-177">Acceso digital inmediato</div>
            <div className="hidden md:block text-taupe-light" data-id="element-178">•</div>
            <div className="flex items-center" data-id="element-179">3 cuotas sin interés*</div>
          </div>
          <p className="text-xs text-taupe-light mt-2 italic" data-id="element-180">
            *según condiciones de Mercado Pago al momento de pagar
          </p>
        </motion.div>
      </div>
    </section>;
}